import { ApiError, EntitlementCRMInfo } from "@blacknut/javascript-sdk/dist";

export enum EntitlementActionTypes {
  ENTITLEMENT_GET_PRICE_INFO_CMR_REQUEST = "ENTITLEMENT_GET_PRICE_INFO_CMR_REQUEST",
  ENTITLEMENT_GET_PRICE_INFO_CMR_SUCCESS = "ENTITLEMENT_GET_PRICE_INFO_CMR_SUCCESS",
  ENTITLEMENT_GET_PRICE_INFO_CMR_ERROR = "ENTITLEMENT_GET_PRICE_INFO_CMR_ERROR",
}

export type EntitlementAction =
  | {
      type: EntitlementActionTypes.ENTITLEMENT_GET_PRICE_INFO_CMR_REQUEST;
    }
  | {
      type: EntitlementActionTypes.ENTITLEMENT_GET_PRICE_INFO_CMR_SUCCESS;
      entitlementId: string;
      info: EntitlementCRMInfo;
    }
  | {
      type: EntitlementActionTypes.ENTITLEMENT_GET_PRICE_INFO_CMR_ERROR;
      error?: ApiError;
    };
